import React from 'react'
import { Navbar } from '../component/Navbar/Navbar'
import { Contact } from '../component/Contact/Contact'
import { Footer } from '../component/Footer/Footer'


export const Contac_page = () => {
    return (
        <div>
            <Navbar/>
            <Contact/>
            <Footer/>
            
        </div>
    )
}
